module.exports = {
  endpointConfig: {
    // host: "http://127.0.0.1:5001/agroinnova-website/us-central1/sendEmailCF",
    host: "https://us-central1-agroinnova-website.cloudfunctions.net/sendEmailCF",
    mailPassword: "cowtsmmtjabontyu",
  },
};
